// Revision Configuration for Document Management
// This config is used by the DocumentRevisionsTab component

export const revisionConfig = {
  entityName: 'Revision',
  
  // Backend API Configuration
  api: {
    baseEndpoint: '/document-management/revision',
    endpoints: {
      list: '',
      create: '',
      update: (id) => `/${id}`,
      delete: (id) => `/${id}`,
      getById: (id) => `/${id}`,
      byDocument: (documentId) => `/by-document/${documentId}`
    }
  },

  // Feature flags
  features: {
    fileAttachments: true,
    approvalRequests: true, // Enable approval request functionality for revisions
  },

  // Review and Approval configuration for revisions
  approval: {
    enabled: true, // Master switch for review and approval functionality
    showInForm: true, // Show review and approval request button in revision form
    showInDetails: true, // Show review and approval integration in revision details
    requireApprovalForPublish: false, // Require review and approval before publishing revision
    allowMultipleApprovals: true, // Allow multiple review and approval requests per revision
    defaultApprovalType: 'single', // Default approval type
    approvalButtonText: 'Request Revision Review and Approval', // Text for review and approval request button
    approvalButtonIcon: 'DocumentTextIcon', // Icon component name (from Icons.js) for approval button icon
    showApprovalStatus: true, // Show current review and approval status in revision view
    showApprovalHistory: true, // Show review and approval history in revision timeline
    formMode: 'modal', // Use modal popup for review and approval form
  },
  
  // Field configuration for revision forms
  fields: [
    {
      name: 'id',
      label: 'ID',
      type: 'hidden'
    },
    {
      name: 'version',
      label: 'Version',
      type: 'text',
      required: true,
      placeholder: 'e.g., 1.0, 2.1, 3.0',
      validation: {
        pattern: '^[0-9]+(\\.[0-9]+)*$',
        message: 'Version must be in format like 1.0, 2.1, etc.'
      }
    },
    {
      name: 'dateIssued',
      label: 'Date Issued',
      type: 'datetime-local',
      required: false
    },
    {
      name: 'issuedById',
      label: 'Issued By',
      type: 'select',
      required: false,
      lookupEndpoint: 'users',
      options: []
    },
    {
      name: 'dateEffective',
      label: 'Effective Date',
      type: 'datetime-local',
      required: false
    },
    {
      name: 'dateExpired',
      label: 'Expiration Date',
      type: 'datetime-local',
      required: false
    },
    {
      name: 'notes',
      label: 'Revision Notes',
      type: 'textarea',
      required: false,
      placeholder: 'Describe the changes made in this revision...',
      rows: 4
    },
  ],
  
  // Form sections for organized display
  formSections: [
    {
      title: 'Revision Information',
      icon: '📄',
      fields: ['version', 'dateIssued', 'issuedById', 'dateEffective', 'dateExpired']
    },
    {
      title: 'Details',
      icon: '📝',
      fields: ['notes']
    }
  ],
  
  // Table configuration for revision listing
  table: {
    columns: [
      {
        name: 'version',
        label: 'Version',
        sortable: true,
        width: '120px'
      },
      {
        name: 'dateIssued',
        label: 'Issued',
        type: 'date',
        sortable: true,
        width: '140px'
      },
      {
        name: 'dateEffective',
        label: 'Effective',
        type: 'date',
        sortable: true,
        width: '140px'
      },
      {
        name: 'dateExpired',
        label: 'Expires',
        type: 'date',
        sortable: true,
        width: '140px'
      },
      {
        name: 'notes',
        label: 'Notes',
        sortable: false,
        width: 'auto'
      },
      {
        name: 'createdAt',
        label: 'Created',
        type: 'datetime',
        sortable: true,
        width: '160px'
      }
    ]
  },

  // Helper methods for approval functionality
  isApprovalEnabled: function() {
    return this.features.approvalRequests && this.approval.enabled;
  },

  shouldShowApprovalInForm: function() {
    return this.isApprovalEnabled() && this.approval.showInForm;
  },

  shouldShowApprovalInDetails: function() {
    return this.isApprovalEnabled() && this.approval.showInDetails;
  },

  requiresApprovalForPublish: function() {
    return this.isApprovalEnabled() && this.approval.requireApprovalForPublish;
  }
};

export default revisionConfig;
